'use client';

import React, { useEffect, useState } from 'react';


type DateProps = {
    utc: string; // ISO string or date string in UTC
};

const LocalTime: React.FC<DateProps> = ({ utc }) => {
    const [localTime, setLocalTime] = useState<string>('');

    useEffect(() => {
        if (!utc) return;
        const date = new Date(utc);
        // Format: YYYY-MM-DD HH:mm (local time)
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            //hour12: true
        };
        // setLocalTime(
        //     date.toLocaleString(undefined, options).replace(',', '')
        // );
        const localFormat = new Intl.DateTimeFormat(navigator.language, options);
        // const format = {...localFormat, ...options}
        // setLocalTime(
        //     date.toLocaleString(undefined, options).replace(',', '')
        // )
        const formattedDate = localFormat.format(date);
        setLocalTime(formattedDate)

    }, [utc]);

    return (
        <span>{localTime}</span>
    );
};

export default LocalTime;